// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2hso0","productName":"Table_productName__3zF_m"};